import { render, staticRenderFns } from "./replyComment.vue?vue&type=template&id=3174de42&scoped=true"
import script from "./replyComment.vue?vue&type=script&lang=js"
export * from "./replyComment.vue?vue&type=script&lang=js"
import style0 from "./replyComment.vue?vue&type=style&index=0&id=3174de42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174de42",
  null
  
)

export default component.exports